import { createApp } from 'vue'
import UlkelerArasiSaatFarki from './UlkelerArasiSaatFarki.vue'
import './assets/global.css'

createApp(UlkelerArasiSaatFarki).mount('#ulkeler-arasi-saat-farki')
